"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cellSummaryWeightedAverage = exports.weightedAverage = exports.getNumericValue = void 0;
const tslib_1 = require("tslib");
const FormatHelper_1 = tslib_1.__importDefault(require("../Utilities/Helpers/FormatHelper"));
const toNumber_1 = tslib_1.__importDefault(require("lodash/toNumber"));
const getNumericValue = (input) => {
    if (typeof input === 'number') {
        return input;
    }
    const numericValue = (0, toNumber_1.default)(input);
    return isNaN(numericValue) ? null : numericValue;
};
exports.getNumericValue = getNumericValue;
const weightedAverage = (params, columnId, weightColumnId) => {
    const { api: gridApi, rowNode: groupRowNode } = params;
    let weightedColumnValueSum = 0;
    let columnValueSum = 0;
    // TODO AFL: improve performance by using the intermediary aggregated values (for nested groups)
    groupRowNode.allLeafChildren.forEach((rowNode) => {
        // when editing values might be converted to strings
        const rawColumnValue = gridApi.getValue(columnId, rowNode);
        const columnValue = (0, exports.getNumericValue)(rawColumnValue);
        const rawWeightedColumnValue = gridApi.getValue(weightColumnId, rowNode);
        const weightedColumnValue = (0, exports.getNumericValue)(rawWeightedColumnValue);
        if (weightedColumnValue !== null) {
            weightedColumnValueSum += weightedColumnValue;
        }
        if (columnValue !== null) {
            columnValueSum += columnValue * weightedColumnValue;
        }
    });
    return {
        toString: () => {
            const result = columnValueSum / weightedColumnValueSum;
            // 0 / 0 = NaN
            if (isNaN(result)) {
                return '';
            }
            return result;
        },
        valueOf: () => {
            const result = columnValueSum / weightedColumnValueSum;
            // 0 / 0 = NaN
            if (isNaN(result)) {
                return 0;
            }
            return result;
        },
        [columnId]: columnValueSum,
        [weightColumnId]: weightedColumnValueSum,
    };
};
exports.weightedAverage = weightedAverage;
const cellSummaryWeightedAverage = ({ numericColumns, selectedCellInfo, adaptableApi, }) => {
    if ((numericColumns === null || numericColumns === void 0 ? void 0 : numericColumns.length) != 1) {
        return '';
    }
    const columnId = numericColumns[0];
    const currentLayout = adaptableApi.layoutApi.getCurrentLayout();
    const selectedColumnAgg = currentLayout.AggregationColumns[columnId];
    if (!selectedColumnAgg ||
        typeof selectedColumnAgg !== 'object' ||
        selectedColumnAgg.type !== 'weightedAverage') {
        return '';
    }
    const weightedColumnId = selectedColumnAgg.weightedColumnId;
    if (weightedColumnId) {
        let sumWeightedValue = 0;
        let sumPrimaryValues = 0;
        let isValid = true;
        selectedCellInfo.gridCells.forEach((gridCell) => {
            if (adaptableApi.gridApi.isGroupRowNode(gridCell.rowNode)) {
                isValid = false;
            }
            if (isValid) {
                const weightedGridCell = adaptableApi.gridApi.getGridCellFromRowNode(gridCell.rowNode, weightedColumnId);
                sumWeightedValue += weightedGridCell.rawValue;
                sumPrimaryValues += weightedGridCell.rawValue * gridCell.normalisedValue;
            }
        });
        if (!isValid) {
            return '';
        }
        const abColumn = adaptableApi.columnApi.getColumnWithColumnId(columnId);
        if (!abColumn) {
            return '';
        }
        const activeFormatColumnsWithDisplayFormat = adaptableApi.formatColumnApi.internalApi.getFormatColumnsWithDisplayFormatForColumn(abColumn);
        if (activeFormatColumnsWithDisplayFormat.length === 1 &&
            activeFormatColumnsWithDisplayFormat[0].DisplayFormat.Formatter === 'NumberFormatter') {
            // there only one FormatColumn on this column, so we will use it to format the aggregated value
            const [singleActiveFormatColumnsWithDisplayFormat] = activeFormatColumnsWithDisplayFormat;
            const options = singleActiveFormatColumnsWithDisplayFormat
                .DisplayFormat.Options;
            if (options) {
                return FormatHelper_1.default.NumberFormatter(sumPrimaryValues / sumWeightedValue, options);
            }
        }
        else {
            // there are multiple (possibly conflicting) FormatColumns for this column, we cannot know which to use
            return FormatHelper_1.default.NumberFormatter(sumPrimaryValues / sumWeightedValue, {
                FractionDigits: 2,
            });
        }
    }
};
exports.cellSummaryWeightedAverage = cellSummaryWeightedAverage;
